var React = require('react');

function Statistics (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.33","y":"6.27","width":"5.9","height":"9.83","fill":"#1e80eb","key":0}),React.createElement("rect",{"x":"10.23","y":"1.85","width":"5.9","height":"14.26","fill":"#1e80eb","key":1})]);
}

Statistics.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Statistics;

Statistics.default = Statistics;
